var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-badge"},[(_vm.icon)?_c('BaseIcon',{attrs:{"name":_vm.icon}}):_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }